import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Divider, Link } from 'rebass';
import _drop from 'lodash/drop';
import log from 'loglevel';
import delve from 'dlv';
import { Modal } from 'semantic-ui-react';

import { Text, Image } from 'Components/Base';
import { FONT_SIZE } from 'Components/Theme';
import { getDiff } from 'Util/DateUtils';
import { getConfig } from 'Util/Config';
import { isBannerCTAEnabled, getRequiredExams, getLatestExamRounds, getPopup } from 'Domain';
import { GlobalDataContext } from 'Util/GlobalDataContext';

import AppContainer from '../AppContainer';
// import Redeem from '../MockExamLink/components/RedeemView';

import { BannerCTA, ExamListTable, Banner, RecommendedCourses, EmptyView } from './components';

const Toolbar = () => (
  <Flex flexDirection={['column', 'row']} justifyContent="space-between" alignItems={'center'}>
    <Box width={'100%'} mb={[2, 0]}>
      <Text fontSize={[FONT_SIZE.large]}>ผลสอบ Mock Exam</Text>
    </Box>
  </Flex>
);

function shouldShowBanner() {
  const bannerEndDate = getConfig().mockOverviewBannerEndDate;
  if (!bannerEndDate) return true;
  return getDiff(bannerEndDate) >= 0;
}

function getDepartmentTitle(deptData, educationTags) {
  let departmentTitle = delve(deptData, ['faculty', 'name'], deptData.name);
  const facultyTagId = delve(deptData, ['faculty', 'tagId']);

  if (facultyTagId && Array.isArray(educationTags)) {
    const matchedTag = educationTags.find(eduTag => eduTag.id === facultyTagId);
    if (matchedTag) {
      departmentTitle = matchedTag.name;
    }
  }

  return departmentTitle;
}

class MockExamOverview extends Component {
  static propTypes = {
    menus: PropTypes.array,
    examRounds: PropTypes.array,
  };

  static defaultProps = {
    examRounds: [],
  };

  state = { modalOpen: true };

  static contextType = GlobalDataContext;

  handleExamClick = (examId, examCardData = {}) => () => {
    const { history } = this.props;
    if (history) {
      const { solutionOnly } = examCardData;
      if (solutionOnly) {
        history.push(`/mockexam/${examId}/solutions`);
      } else {
        history.push(`/mockexam/${examId}`);
      }
    }
  };

  handleManageExamClick = () => {
    const { history, examRounds } = this.props;
    const { roundCode } = getLatestExamRounds(examRounds);
    history.push(`/school/manage-mock-exam/${encodeURIComponent(roundCode)}`);
  };

  handleLinkSchoolClick = () => {
    const { history } = this.props;
    if (history) {
      history.push('/school');
    }
  };

  handleClose = () => this.setState({ modalOpen: false });

  renderBannerModal = () => {
    console.log(isBannerCTAEnabled);
    if (isBannerCTAEnabled) {
      const { image, link } = getPopup();
      return (
        <Modal open={this.state.modalOpen} onClose={this.handleClose} closeIcon>
          <Modal.Content>
            <Link href={link} target="_blank">
              <Image src={image} />
            </Link>
          </Modal.Content>
        </Modal>
      );
    }
    return null;
  };

  render() {
    const { menus, examRounds, myMockWishDepartmentData, studentData } = this.props;
    const lastestExamRound = getLatestExamRounds(examRounds);
    const restExamRounds = _drop(examRounds, 1);
    const isShowScheduleBanner = shouldShowBanner();

    // fetch dept details for MF CTA Banners
    const departmentTitle = getDepartmentTitle(
      myMockWishDepartmentData,
      this.context.educationTags,
    );

    log.debug('requiredExams:', getRequiredExams(myMockWishDepartmentData));
    return (
      <AppContainer menus={menus}>
        {this.renderBannerModal()}
        <Box>
          {isBannerCTAEnabled && (
            <Box mb={4}>
              {/* <BannerCTA departmentTitle={departmentTitle} /> */}
              <Banner
                images={{
                  mobile:
                    'https://tcas-assets.skooldio.com/images/campaign/2020_jan_mockExam/mockExam_header_tablet.jpg',
                  tablet:
                    'https://tcas-assets.skooldio.com/images/campaign/2020_jan_mockExam/mockExam_header_tablet.jpg',
                  desktop:
                    'https://tcas-assets.skooldio.com/images/campaign/2020_jan_mockExam/mockExam_header_desktop.jpg',
                }}
                onClick={() =>
                  window.open(
                    'https://shoponline.ondemand.in.th/?utm_source=Head-Banner&utm_medium=Web-Mock&utm_campaign=Mock-Campaign',
                  )
                }
              />
            </Box>
          )}
          <Toolbar />
          <Divider borderColor="borderGrey" style={{ marginBottom: 16 }} />
          {isShowScheduleBanner && (
            <Box mx="auto" mb={4}>
              <Image
                src="https://tcas-assets.skooldio.com/banner/schedule_banner_feb2019.jpg"
                style={{ margin: '0 auto', maxWidth: 480, width: '100%' }}
                alt="MOCK Exam Schedule February 2019"
              />
            </Box>
          )}
          {(!examRounds || examRounds.length === 0) && (
            <EmptyView onLinkSchoolClick={this.handleLinkSchoolClick} />
          )}
          {examRounds && examRounds.length > 0 && (
            <Fragment>
              <Box mb={48}>
                <ExamListTable
                  title={lastestExamRound.title}
                  examCards={lastestExamRound.examCards}
                  onExamClick={this.handleExamClick}
                  onManageExamClick={this.handleManageExamClick}
                  showManageButton={lastestExamRound.isActive}
                />
              </Box>
              <Banner
                images={{
                  mobile: 'https://tcas-assets.skooldio.com/images/banner-upscore-mobile.png',
                  tablet: 'https://tcas-assets.skooldio.com/images/banner-upscore-tablet.png',
                  desktop: 'https://tcas-assets.skooldio.com/images/banner-upscore-desktop.png',
                }}
              />
              <RecommendedCourses
                examCards={lastestExamRound.examCards}
                myMockWishDepartmentData={getRequiredExams(myMockWishDepartmentData)}
                studentMajor={studentData.major}
              />
              {restExamRounds.map(round => {
                return (
                  <Box mb={48} key={round.title}>
                    <ExamListTable
                      title={round.title}
                      examCards={round.examCards}
                      onExamClick={this.handleExamClick}
                      onManageExamClick={this.handleManageExamClick}
                      showManageButton={round.isActive}
                    />
                  </Box>
                );
              })}
            </Fragment>
          )}
        </Box>
      </AppContainer>
    );
  }
}

export default MockExamOverview;
